// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2CVnS"};